import { observer } from "mobx-react";

import BaseComponent from "@component/BaseComponent";
import CertificationList from "./List";

@observer
export default class Certifications extends BaseComponent<PropsFromRouter> {
  render() {
    return (
      <>
        <CertificationList match={this.props.match} />
      </>
    );
  }
}
